import Vue from "vue";
import Router from "vue-router";
import Homepage from "./components/home/Homepage";
import Search from "@/components/Search";
import Reports from "@/components/Reports";
import LibraryOrders from "@/components/LibraryOrders";
Vue.use(Router);


export default new Router({
    routes: [
        {path: '/', meta:{title:'Αρχική Σελίδα'}, component: Homepage, beforeEnter: checkIfPathExists},
        {path: '/search', meta:{title:'Αναζήτηση'}, component: Search, beforeEnter: checkIfPathExists},
        {path: '/reports', meta:{title:'Αναφορές'}, component: Reports, beforeEnter: checkIfPathExists},
        {path: '/libraryOrders', meta:{title:'Παραγγελίες Βιβλίων'}, component: LibraryOrders, beforeEnter: checkIfPathExists},
        
    ]
});

function checkIfPathExists(to, from, next) {
    // let navBarItems = JSON.parse(JSON.stringify(store.getters.navigationItems));
    // for(let k=0;k<navBarItems.length;k++){
    //     if( navBarItems[k].link===to.fullPath){
    //         store.commit('setPageHeader', navBarItems[k].label);
    //         break;
    //     }
    // }
    // if (to.fullPath == from.fullPath) {
    //     console.log('asdasdas');
    //     return
    // }
    next();
}